'use strict';

angular.module('AdminControllers')

.controller('AdminController', ['$scope', 'employeeService', 'topBar', 'authenticatedUser', '$translate',
                       function ($scope, employeeService, topBar, authenticatedUser, $translate) {

    $translate('iam.admin.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-wrench');
    });

    $scope.currentIdentity = authenticatedUser.IdentityName;
    $scope.synchronizationActive = false;
    $scope.synchronizationExternalEmployeesActive = false;
    $scope.userIsAllowedToSyncBU = authenticatedUser.IsInAdministrationGroup;
    $scope.userIsAllowedToSyncExternalEmployees = authenticatedUser.IsInAdministrationGroup || authenticatedUser.IsInHRGroup;

    $scope.synchronizeAllActiveEmployees = function () {
        $scope.synchronizationActive = true;
        employeeService.synchronizeAllActiveEmployees().then(function (res) {
            $scope.synchronizationActive = false;
        });
    }

    $scope.synchronizeAllExternalEmployees = function () {
        $scope.synchronizationExternalEmployeesActive = true;
        employeeService.synchronizeAllExternalEmployees().then(function (res) {
            $scope.synchronizationExternalEmployeesActive = false;
        });
    }

}]);
